import toast from "react-hot-toast";
import { formatNumber } from "../../utils/utils";
import { formatDateDb } from "../../utils/tools";

const { clientAPI } = require("../client");
export const commissionConfirmationCall = {
  export: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search) options.search = param.search;
      if (param.projectId) options.projectId = param.projectId;
      if (param.employeeId) options.approverConfirmId = param.employeeId;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/locking?${queryParams}`);

      const dataExport = response?.items.map((item, index) => {
        let status='';
        if(item?.confirmCommissionStatus==='NEW'){
            status = 'Đang chờ duyệt';
        }else if(item?.confirmCommissionStatus==='APPROVED'){
            status = 'Đã duyệt';
        }else{
            status = 'Không được duyệt';
        }

        return {
          code: item?.code || "",
          confirmCommissionStatus: item?.confirmCommissionStatus ? status : "-",
          saleOpeningEvent: item?.saleOpeningEvent?.name || "-",
          project: item?.project?.name || "-",
          priceForCommission: item?.apartment?.priceForCommission
            ? `${formatNumber(item?.apartment?.priceForCommission)} VNĐ`
            : "0 VNĐ",
          serviceFeeType: item?.serviceFee?.name || "-",
          approver: item?.approverConfirm?.fullName || "-",
          lockingParticipant:
            item?.lockingParticipant
              ?.map((p) => p?.employee?.fullName)
              .filter(Boolean)
              .join(", ") || "-",
          bookingTime: item?.bookingTime
            ? formatDateDb(item?.bookingTime)
            : "-",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
